import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core'
import { Subscription } from 'rxjs'
import { CampaignPluginName } from '../../../../../shared/models/campaign/campaign'
import { NewsLetterNotificationParams } from '../../../../../shared/models/campaign/coupon-box-notification.model'
import { QuickSetupService } from '../../services/quick-setup.service'

@Component({
    templateUrl: './quick-setup-newsletter.component.html',
    standalone: false
})
export class QuickSetupNewsletterComponent implements OnInit, OnDestroy {
  @ViewChild('controlsRef', { read: ViewContainerRef, static: true }) controlsRef: ViewContainerRef
  private subscription = new Subscription()
  pluginType = CampaignPluginName.NewsLetterNotification
  public params: NewsLetterNotificationParams

  constructor(
    private quickSetupService: QuickSetupService,
  ) {
  }

  ngOnInit(): void {
    this.subscription.add(
      this.quickSetupService.params$.subscribe(params => {
        this.params = {...params} as NewsLetterNotificationParams
      })
    )
    // Set child container
    this.quickSetupService.childContainer = this.controlsRef
    // Load first step
    this.quickSetupService.loadChildStep('inputs')
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
